import { Select, Option, Input, Button } from "@mui/joy";
import React, { useEffect, useState } from "react";
import totalLocationData from "../../../../../../data/locationdata";
import styles from "../components/style/configstyle.module.css"
import { Create } from "@mui/icons-material";
import { Backdrop, Box, CircularProgress, LinearProgress, Modal } from "@mui/material";
import { englishLocationToKorean } from "../../../../../../data/locationFuntion";
import { getFetch, postFetch } from "../../../../../../fetch/fetch";
import useStyles2 from "../../../money/etc/useStyles";
import { DataGridPremium, GridRowModel } from "@mui/x-data-grid-premium";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    borderRadius: "16px",
    boxShadow: 24,
    p: 3,
    paddingLeft: 5,
    paddingRight: 5
};





const ShopSalaryConfig: React.FC<any> = (props) => {

    const [location, setLocation] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [selectedTitle, setSelectedTitle] = useState("");
    const [selectedKind, setSelectedKind] = useState("");
    const [selectedColumnKey, setSelectedColumnKey] = useState("");
    const [update, setUpdate] = useState(0);
    const [getLoading, setGetLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [hourlyWage, setHourlyWage] = useState(0);
    const [jobsData, setJobsData] = useState<any>([]);
    const classes = useStyles2();
    const [disabled, setDisabled] = useState(false);
    const [data, setData] = useState<any>(null);

    const [btnLoading, setBtnLoading] = useState(false);

    const [rows, setRows] = useState<any>([]);
    const [columns, setColumns] = useState<any>([
        {
            field: "korean", headerName: "근무 종류", width: 150
        },
        {
            field: "startTime", headerName: "시작 시간", width: 150,
            renderCell: (params: any) => {

                const english = params.row.english;
                const korean = params.row.korean;

                return (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <span>
                            {params.value}
                        </span>
                        <span style={{
                            cursor: "pointer",
                            marginLeft: "15px"
                        }}
                            onClick={() => {
                                handleOpenModal(korean + " 시작 시간 수정(00:00 타입)", english, "startTime");
                            }}
                        >
                            <Create
                                fontSize="small"
                                color="disabled"
                            />
                        </span>
                    </div>
                )
            }
        },
        {
            field: "endTime", headerName: "종료 시간", width: 150,
            renderCell: (params: any) => {

                const english = params.row.english;
                const korean = params.row.korean;

                return (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <span>
                            {params.value}
                        </span>
                        <span style={{
                            cursor: "pointer",
                            marginLeft: "15px"
                        }}
                            onClick={() => {
                                handleOpenModal(korean + " 종료 시간 수정(00:00 타입)", english, "endTime");
                            }}
                        >
                            <Create
                                fontSize="small"
                                color="disabled"
                            />
                        </span>
                    </div>
                )
            }
        },
        {
            field: "realMinutesString", headerName: "실제 근무 시간", width: 180,
            renderCell: (params: any) => {

                const english = params.row.english;
                const korean = params.row.korean;

                return (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <span>
                            {params.value}
                        </span>
                        <span style={{
                            cursor: "pointer",
                            marginLeft: "15px"
                        }}
                            onClick={() => {
                                handleOpenModal(korean + " 실제 근무 시간 수정(분 단위)", english, "realMinutes");
                            }}
                        >
                            <Create
                                fontSize="small"
                                color="disabled"
                            />
                        </span>
                    </div>
                )
            }
        },
        {
            field: "nightWorkMinutes", headerName: "야간수당 포함 시간(분)", width: 180,
            renderCell: (params: any) => {

                const english = params.row.english;
                const korean = params.row.korean;

                return (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <span>
                            {params.value}분
                        </span>
                        <span style={{
                            cursor: "pointer",
                            marginLeft: "15px"
                        }}
                            onClick={() => {
                                handleOpenModal(korean + " 야간수당 포함 시간 수정(분 단위)", english, "nightWorkMinutes");
                            }}
                        >
                            <Create
                                fontSize="small"
                                color="disabled"
                            />
                        </span>
                    </div>
                )
            }
        },
        {
            field: "isAvailable", headerName: "근무 가능 여부", width: 150, type: "boolean", editable: true
        },
        {
            field: "mockExamIncentive", headerName: "모의고사 인센티브", width: 150, type: "boolean", editable: true
        },
        {
            field: "mockExamIncentiveAmount", headerName: "모의고사 인센티브 금액", width: 200,
            renderCell: (params: any) => {

                const english = params.row.english;
                const korean = params.row.korean;

                // 모의고사 인센티브가 O일 때만 금액 표시·수정 가능
                if (!params.row.mockExamIncentive) {
                    return (
                        <span>-</span>
                    )
                }

                return (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <span>
                            {(params.value ?? 0).toLocaleString()}원
                        </span>
                        <span style={{
                            cursor: "pointer",
                            marginLeft: "15px"
                        }}
                            onClick={() => {
                                handleOpenModal(korean + " 모의고사 인센티브 금액 수정(원)", english, "mockExamIncentiveAmount");
                            }}
                        >
                            <Create
                                fontSize="small"
                                color="disabled"
                            />
                        </span>
                    </div>
                )
            }
        }
    ]);

    useEffect(() => {

        setColumns((prevColumns: any) => {
            return [...prevColumns]
        })

    }, [jobsData]);


    const [value, setValue] = useState("");



    useEffect(() => {

        if (!location) {
            return;
        }

        getData();


    }, [location, update]);

    const getData = async () => {

        try {

            setRows([]);

            setGetLoading(true);

            const result: any = await getFetch("/dashboard/salary/getshopsalaryconfig?location=" + location);

            console.log(result);

            if (result.message === "success") {

                setHourlyWage(+result.hourlyWage);

                const jobsData = result.jobs || [];

                setJobsData([...jobsData]);
                
                const newRows: any = [];

                jobsData.forEach((job: any, index: number) => {

                    const newRow: any = {};

                    newRow.id = index;

                    newRow.english = job.english;
                    newRow.korean = job.korean;
                    newRow.startTime = job.time.start;
                    newRow.endTime = job.time.end;
                    newRow.realMinutes = job.realMinutes;
                    newRow.realMinutesString = `${Math.floor(job.realMinutes / 60)}시간 ${job.realMinutes % 60}분`;

                    newRow.nightWorkMinutes = job.nightWorkMinutes ?? 0;

                    newRow.isAvailable = (job.isAvailable === undefined || job.isAvailable === null || job.isAvailable) ? true : false;

                    newRow.mockExamIncentive = job.mockExamIncentive ?? false;
                    newRow.mockExamIncentiveAmount = job.mockExamIncentiveAmount ?? 0;

                    newRows.push(newRow);

                });

                setRows([...newRows]);

            }

            setGetLoading(false);

        } catch (e) {
            console.log(e);
        }

    }

    const handleOpenModal = (selectedTitle: string, selectedKind: string, selectedColumnKey : string = "") => {

        setSelectedTitle(selectedTitle);
        setSelectedKind(selectedKind);
        setSelectedColumnKey(selectedColumnKey);

        setOpenModal(true);
    }

    const handleModalClose = () => {

        setOpenModal(false);
        setSelectedTitle("");
        setSelectedKind("");
        setSelectedColumnKey("");

        setValue("");

    }

    const letsUpdate = async () => {
        try {

            if (!location || !value || !selectedKind) {
                console.log(location, value, selectedKind);
                alert("모든 항목을 선택해주세요.");
                return;
            }


            // HH:MM 24시간 형식 체크
            const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

            const numberRegex = /^\d+$/;

            if (selectedColumnKey === "startTime" || selectedColumnKey === "endTime") {
                if (!timeRegex.test(value)) {
                    alert("시간 형식이 올바르지 않습니다. 예) 00:00, 07:30, 12:30, 23:20");
                    return;
                }
            }

            // realMinutesString, nightWorkMinutes 일 때 숫자만 가능
            if (selectedColumnKey === "realMinutes" || selectedColumnKey === "nightWorkMinutes" || selectedColumnKey === "mockExamIncentiveAmount") {
                if (!numberRegex.test(value)) {
                    alert("숫자만 입력 가능합니다.");
                    return;
                }
            }

            setBtnLoading(true);

            var body;

            if (selectedColumnKey) {

                const newJobsData = jobsData;

                var data: any;

                newJobsData.forEach((job: any) => {
                    if (job.english === selectedKind) {
                        data = job;
                    }
                })

                if (!data) {
                    return;
                }

                switch (selectedColumnKey) {
                    case "startTime":
                        data.time.start = value;
                        break;
                    case "endTime":
                        data.time.end = value;
                        break;
                    case "realMinutes":
                        data.realMinutes = +value;
                        break;
                    case "nightWorkMinutes":
                        data.nightWorkMinutes = +value;
                        break;
                    case "mockExamIncentiveAmount":
                        data.mockExamIncentiveAmount = +value;
                        break;
                    default:
                        break;
                }


                body = {
                    location,
                    kind: selectedKind,
                    value: data
                }

            }else{
                body = {
                    location,
                    kind: selectedKind,
                    value
                }
            }



            const result: any = await postFetch("/dashboard/salary/updateshopsalaryconfig", body);

            if (result.message === "success") {
                props.notify("success", "업무 설정이 수정되었습니다.");
                handleModalClose();
                setUpdate(Math.random());
            }

            setBtnLoading(false);

        } catch (e) {
            console.log(e);
        }
    }

    const handleEditCommit = React.useCallback(
            async (newRow: GridRowModel, old: any) => {
                var field = "";
    
    
                for (const [key, value] of Object.entries(newRow)) {
                    if (value !== old[key]) {
                        field = key;
                    }
                }

                if (!field) {
                    console.log("no field edited");
                    return old;
                }

                console.log("edited field:", field);
                console.log(newRow[field]);
                console.log(newRow["english"]);

                const english = newRow["english"];

                const newJobsData = jobsData;

                if(field !== "isAvailable" && field !== "mockExamIncentive"){
                    console.log("not editable field edited");
                    return old;
                }

                var data : any;

                console.log(english);
                console.log(newJobsData);

                newJobsData.forEach((job : any) => {
                    if(job.english === english){
                        data = job;
                    }
                })

                console.log(newJobsData);

                if(!data){
                    console.log("no data found");
                    return old;
                }

                if (field === "isAvailable") {
                    data.isAvailable = newRow[field];
                } else {
                    data.mockExamIncentive = newRow[field];
                }

                fetch("https://peetsunbae.com/dashboard/salary/updateshopsalaryconfig", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include",
                    body: JSON.stringify({
                        location: location,
                        kind: english,
                        value: data
                    })
                })
    
                return newRow;

            }, [jobsData, location]
        );
    
        const handleProcessRowUpdateError = React.useCallback((error: Error) => {
    
            alert(error.message);
        }, []);


    return (
        <div>
            <div style={{ height: "30px" }} />
            <div>
                <div style={{
                    fontSize: "20px",
                    fontWeight: 600,
                    marginTop: "15px"
                }}>
                    지점 선택
                </div>
                <Select placeholder="지점을 선택해주세요"
                    value={location}
                    onChange={(e: any, newValue: any) => {

                        setLocation(newValue)
                    }}
                    style={{ width: "300px", marginTop: "10px" }}
                >
                    {
                        totalLocationData.map((data, index: number) => {

                            if (!data.academy.includes("sunbae") && !data.academy.includes("bundangsunbae")) {
                                return;
                            }

                            if (data.english === "total") {
                                return;
                            }

                            return (
                                <Option key={index} value={data.english}>
                                    {data.korean}
                                </Option>
                            )

                        })
                    }
                </Select>

            </div>
            {
                location
                    ?
                    getLoading
                        ?
                        <div style={{ marginTop: "40px" }}>
                            <LinearProgress />
                        </div>
                        :
                        <>
                            <div>
                                <div style={{
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    marginTop: "40px"
                                }}>
                                    시급 설정
                                </div>
                                <div className={styles.container} style={{
                                    marginTop: "15px"
                                }}>
                                    <div className={styles.containerTitle}>
                                        기본 시급
                                    </div>
                                    <div className={styles.containerContent}>
                                        <div style={{
                                            marginRight: "15px"
                                        }}>
                                            {hourlyWage.toLocaleString()}원
                                        </div>
                                        <div style={{
                                            cursor: "pointer"
                                        }}
                                            onClick={() => {

                                                var title = "시급 수정";

                                                const koreanLocation = englishLocationToKorean(location);

                                                if (koreanLocation) {
                                                    title += ` (${koreanLocation})`;
                                                }

                                                handleOpenModal(title, "hourlywage");
                                            }}
                                        >
                                            <Create />
                                        </div>
                                    </div>
                                </div>
                                <div style={{
                                    fontSize: "20px",
                                    fontWeight: 600,
                                    marginTop: "40px"
                                }}>
                                    근무 설정
                                </div>
                                <div className={classes.root} style={{ height: "650px", width: "1500px", marginTop: "15px", backgroundColor : "white" }}>
                                    <DataGridPremium
                                        rows={rows}
                                        columns={columns}
                                        density="compact"
                                        loading={getLoading}
                                        hideFooter
                                        processRowUpdate={handleEditCommit}
                                        onProcessRowUpdateError={handleProcessRowUpdateError}
                                    />
                                </div>
                            </div>
                        </>
                    :
                    ""
            }


            <Modal
                open={openModal}
                onClose={() => {
                    handleModalClose();
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div style={{
                        fontSize: "18px",
                        fontWeight: 600
                    }}>
                        {selectedTitle}
                    </div>
                    <div style={{ marginTop: "12px" }}>
                        {/* Modal content based on selectedType and selectedPeriod can be added here */}
                        <Input
                            value={value}
                            onChange={(e: any) => {
                                setValue(e.target.value);
                            }}
                        />
                    </div>
                    <div style={{
                        marginTop: "28px"
                    }}>
                        <Button
                            variant="solid"
                            fullWidth
                            onClick={() => { letsUpdate() }}
                            disabled={!value}
                            loading={btnLoading}
                        >
                            수정하기
                        </Button>
                    </div>
                </Box>
            </Modal>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </div>
    )
}

export default ShopSalaryConfig;